import { Header as MastheadHeader } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

import { SPOTIFYCOM_URL } from 'lib/shared/config/config';
import { getMastheadDirOverride, useMarketInfo } from 'context/MarketInfo/MarketInfoProvider';
import { MastheadHeaderType } from 'etc/types';
import { useIsPlainPage } from 'context/PlainPage/plainPage';

const FALLBACK_HEADER = {
  navigation: {
    brand: {
      href: SPOTIFYCOM_URL,
      alt: 'Spotify',
    },
  },
} as MastheadHeaderType;

interface Props {
  headerData?: MastheadHeaderType;
}

const Container = styled.div`
  a[href='#'] {
    cursor: default;
  }

  header {
    background: transparent !important;
  }
`;

/*
 * this is copied from support-site-web to ensure the same styling
 * https://ghe.spotify.net/first-aid/support-site-web/blob/f3b05247bfdf65836c53bcf1b120a211ba012a20/src/components/Header/Header.tsx#L26-L43
 */
const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  z-index: -1;
  background: linear-gradient(98.85deg, rgba(18, 18, 18, 0.3) 0%, var(--background-base) 100%),
    linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, var(--background-base) 100%), var(--text-bright-accent);
`;

const Header = ({ headerData }: Props) => {
  const isPlainPage = useIsPlainPage();
  const { market } = useMarketInfo();

  if (isPlainPage) {
    return null;
  }
  const data = headerData || FALLBACK_HEADER;

  return (
    <Container dir={getMastheadDirOverride(market)}>
      <Gradient aria-hidden="true" />
      <MastheadHeader {...data} transparent fixed={false} />
    </Container>
  );
};

export default Header;
